import React, { useState } from "react";
import { View, Text, Image, ScrollView } from "react-native";
import DropDownPicker from "react-native-dropdown-picker";
import { TextInput } from "react-native-paper";

import HeaderDefault from "../../components/HeaderDefault";
import Button from "../../components/Button";

import styles from "./styles";
import { FormattedMessage } from "react-intl";
import { id } from "date-fns/locale";

const Sell = () => {
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(null);
    const [items, setItems] = useState([
        {
            label: "GPX",
            value: "gpx",
            icon: () => (
                <Image
                    source={require("../../../assets/imgs/gpx.png")}
                    style={styles.iconSelect}
                />
            ),
        },
    ]);
    return (
        <>
            <HeaderDefault title={<FormattedMessage id="sell.venderTitulo"/>}/>

            <ScrollView style={styles.content}>
                <Text style={styles.title}>
                    <FormattedMessage id="sell.desejoVender"/>
                </Text>

                
                <View style={styles.contentSelect}>
                    <FormattedMessage id="sell.selecione">
                        {placeholder =>
                        <DropDownPicker
                            open={open}
                            value={value}
                            items={items}
                            containerStyle={styles.dropdown}
                            placeholder= {placeholder}
                            setOpen={setOpen}
                            setValue={setValue}
                            setItems={setItems}
                        />}
                    </FormattedMessage>

                </View>
                <Text style={styles.textAmount}>
                    <FormattedMessage id="sell.quantidadeDisponivel"/>{" "}
                    <Text style={{ fontWeight: "400" }}>
                        <FormattedMessage id="sell.32,280Brl"/>
                    </Text>
                </Text>

                <TextInput
                    left={<TextInput.Icon name="currency-brl" />}
                    style={{ backgroundColor: "#F2F2F2", marginTop: 50 }}
                    keyboardType="numeric"
                />
                <Text style={styles.price}>
                <FormattedMessage id="sell.1Gpx"/>
                    </Text>
            </ScrollView>

            <Button route={"PaymentMethodSell"} text={ <FormattedMessage id="sell.continuar"/>} />
        </>
    );
};

export default Sell;
